import Input from './Input';
import InputLabel from './InputLabel';
import StatusLabel from './StatusLabel';

export default Input;
export { InputLabel, StatusLabel };
